export default "/images/vendor/flag-icons/flags/4x3/dm.svg?ad730a312756ab678baa96018e3be2a7";